import actions from "./actions";

export default {
  namespaced: true,
  state: {
    resources: {},
    lessons: [],
    masterclasses: [],
    books: [],
    lives: [],
    audios: []
  },
  mutations: {
    setResources(state, { id, resources }) {
      const data = { ...state.resources };
      data[id] = resources;
      state.resources = data;
    },
    setLessons(state, lessons) {
      state.lessons = lessons;
    },
    setMasterclasses(state, masterclasses) {
      state.masterclasses = masterclasses;
    },
    setBooks(state, books) {
      state.books = books;
    },
    setLives(state, lives) {
      state.lives = lives;
    },
    setAudios(state, audios) {
      state.audios = audios;
    }
  },
  actions
};
